import React from "react";
import TestimonialsPremium from "../sections/TestimonialsPremium";

const ClientStoriesPage = () => {
  return (
    <main>
      <TestimonialsPremium />
    </main>
  );
};

export default ClientStoriesPage;
